module.exports = __webpack_public_path__ + "static/media/icomoon.b54e46ef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/icomoon.svg?l4wga5
// module id = 1646
// module chunks = 0